import cn from 'classnames';
import PropTypes from 'prop-types';

import css from 'styles/components/productdetail/ask/voteBox.scss';

const makeReportStuff = ({ item: { justReported, key }, onReportAskItem }) => {
  let reportClasses, reportFn = null;
  if (justReported) {
    reportClasses = cn(css.report, css.justReported);
  } else {
    reportClasses = css.report;
    reportFn = () => onReportAskItem(key);
  }
  return { reportClasses, reportFn };
};

const makeVoteFunctions = ({ item: { key, myVote }, onAddAskDownvote, onAddAskUpvote }) => {
  let downvoteFn = () => onAddAskDownvote(key);
  let upvoteFn = () => onAddAskUpvote(key);
  if (myVote === -1) {
    downvoteFn = () => onAddAskUpvote(key);
  } else if (myVote === 1) {
    upvoteFn = () => onAddAskDownvote(key);
  }
  return { downvoteFn, upvoteFn };
};

const VoteBox = props => {
  const { item: { justReported, myVote, upvotes, votes }, isQuestion } = props;
  const { downvoteFn, upvoteFn } = makeVoteFunctions(props);
  const { reportClasses, reportFn } = makeReportStuff(props);
  return (
    <div className={isQuestion ? css.questionVoteBox : css.answerVoteBox}>
      <button
        type="button"
        className={cn(css.upvote, { [css.voted]: myVote > 0 })}
        onClick={upvoteFn}
        aria-label={isQuestion ? 'Upvote Question' : 'Helpful Answer?'}
      >
        {isQuestion || 'Helpful?'}
      </button>
      <span className={css.numVotes}>{isQuestion ? votes : upvotes}</span>
      {' '}
      <span className={css.votesDescription}>{isQuestion ? 'Votes' : 'found this answer helpful.'}</span>
      {isQuestion &&
        <button
          type="button"
          className={cn(css.downvote, { [css.voted]: myVote < 0 })}
          onClick={downvoteFn}
          aria-label="Downvote Question"/>
      }
      {' '}
      <button
        type="button"
        className={reportClasses}
        onClick={reportFn}
        aria-label={isQuestion ? 'Report abuse of question' : 'Report abuse of answer'}
      >
        {isQuestion ? 'Report' : 'Report abuse'}
      </button>
      {justReported && <span>Reported</span>}
    </div>
  );
};

const itemBasePropTypes = {
  justReported: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  myVote: PropTypes.number.isRequired
};

const questionPropTypes = PropTypes.shape({
  ...itemBasePropTypes,
  votes: PropTypes.number.isRequired
}).isRequired;

const answerPropTypes = PropTypes.shape({
  ...itemBasePropTypes,
  upvotes: PropTypes.number.isRequired
}).isRequired;

VoteBox.propTypes = {
  onAddAskDownvote: PropTypes.func.isRequired,
  onAddAskUpvote: PropTypes.func.isRequired,
  onReportAskItem: PropTypes.func.isRequired,
  item: PropTypes.oneOfType([questionPropTypes, answerPropTypes]),

  isQuestion: PropTypes.bool.isRequired
};

export default VoteBox;
